<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form ref="form" label-width="140px" :model="dataForm">
        <el-form-item label="编号：">
          {{ dataForm.BusinessId }}
        </el-form-item>
        <el-form-item label="求助类型：">
          {{ dataForm.Type }}
        </el-form-item>
        <el-form-item label="求助人姓名：">
          {{ dataForm.Name }}
        </el-form-item>
        <el-form-item label="性别：">
          {{ showSex(dataForm.Sex) }}
        </el-form-item>
        <el-form-item label="身份证号码：">
          {{ dataForm.IdentityCard }}
        </el-form-item>
        <el-form-item label="家庭住址：">
          {{ dataForm.Address }}
        </el-form-item>
        <el-form-item label="申请表：">
             <!-- <el-image 
                  style="width: 100px; height: 100px"
                  :src="'/api/File/Download?Id='+dataForm.Files" 
                  :preview-src-list="['/api/File/Download?Id='+dataForm.Files]">
              </el-image> -->
              <el-row>
                <el-col :span="12" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{file.FileName}}</el-col>
                <el-col
                  :span="12"
                  style="text-align: right; padding-right: 20px"
                >
                  <el-button type="text" @click="downloadFile">下载</el-button>
                </el-col>
              </el-row>
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      fileList: [], //附件数组
      width: "50%",
      typeName: "", //分类名称
      file: {}
    };
  },
  components: {
    workbenchDetail,
    OfUpload,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QuerySeekHelpApplyById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getlistfile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditSeekHelpApply(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    // //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.Files === undefined || that.dataForm.Files === null) {
        return;
      }
      let params = { Id: that.dataForm.Files };
      api.QueryBigSickApplyFileByIds(params).then((res) => {
        if (res.data.Code == 0) {
          that.file = res.data.Data[0];
        }
      });
    },
    //下载附件
    downloadFile() {
      const vm = this
      saveAs(vm.file.Url, vm.file.FileName);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hidePic >>> .el-upload-list__item-delete {
  display: none !important;
}
.hidePic >>> .el-icon-close {
  display: none !important;
}
.hidePic >>> .el-icon-close-tip {
  display: none !important;
}
.hideFile >>> .el-upload-list__item-delete {
  display: none !important;
}
.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>
